import { uniqueArrayOnKey, uriEncodeObject } from '@helper/globalHelpers'
import { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'
import { City } from './model-types/City'
import { Country } from './model-types/Country'
import { State } from './model-types/State'
import { uniqWith } from 'lodash'

export const useCountries = () => {
  const url = `${API_ENDPOINTS.GET_COUNTRIES}`

  const { data, isError, isLoading } = useApi(url)
  return {
    countries: data?.data?.sort((a: Country, b: Country) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    ) as Country[],
    isLoading,
    isError,
  }
}

export const useStates = (
  countryId?: string,
  filter?: Record<string, string>,
) => {
  let url = ''
  if (countryId) {
    const endpoint = API_ENDPOINTS.GET_STATES(countryId || '')
    const alphabeticFilter = { ...filter, sort: '+name' }
    url = `${endpoint}?${uriEncodeObject(alphabeticFilter)}`
  }
  const { data, isError, isLoading } = useApi(url)

  const states = uniqueArrayOnKey<State>(data?.data, 'code')

  return {
    states,
    isLoading,
    isError,
  }
}
export const useCities = (
  stateId?: string,
  filter?: Record<string, string>,
) => {
  let url = ''
  if (stateId) {
    const endpoint = API_ENDPOINTS.GET_CITIES(stateId)
    const alphabeticSort = { ...filter, sort: '+name' }
    url = `${endpoint}?${uriEncodeObject(alphabeticSort)}`
  }
  const { data, isError, isLoading } = useApi(url)

  let cities: City[] = []

  if (data?.data) {
    cities = uniqWith<City>(
      data?.data,
      (arrVal, othVal) => arrVal?.geoId === othVal?.geoId,
    )
  }

  return {
    cities,
    isLoading,
    isError,
  }
}
